
import React from 'react'

const VastPROLogoContainer = ({ containerObject, dataZone, templateName, contentId }) => {
    var content = containerObject;
    
    var LogoItem = content.VastPROLogoContainer
    
    return (
        // < !--Logo Start-- >
        <div  data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>

        <section class="digtal-marketing-logo mt-5">
            <div class="container">
                <div class="py-5 px-4 rounded-3">
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <h5 class="mb-4" dangerouslySetInnerHTML={{ __html: content.containerTitle }}></h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto">
                            <div class="swiper digi-logo-slider">
                                <div class="swiper-wrapper">
                                    
                                    {LogoItem ? LogoItem.map((item)=>{
                                        
                                    return(
                                    <div class="swiper-slide">
                                        <div class="single-logo">
                                            <img src={`${item.mainImage ? item.mainImage : ""}`} width="150" alt="clients logo" class="img-fluid p-1 p-md-2 p-lg-3 m-auto" data-aos="fade-up" data-aos-delay="200" />
                                        </div>
                                    </div>
                                     )
                                    })
                                    :"" } 
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
        // <!--Logo End-- >
    )
}

export default VastPROLogoContainer